import { SidePanelItem } from './types'

export const SIDE_PANEL_ITEMS: Record<string, SidePanelItem> = {
  HOME: {
    title: 'Home',
    to: 'home',
  },
  LIVESTREAM: {
    title: 'Live TV',
    to: 'livestream',
  },
  SHOWS: {
    title: 'Shows',
    to: 'shows',
  },
  MY_LIST: {
    title: 'My List',
    to: 'my-list',
  },
  MY_STATION: {
    title: 'My Station',
    to: 'my-station',
  },
  SEARCH: {
    title: 'Search',
    to: 'search',
  },
  SETTINGS: {
    title: 'Settings',
    to: 'settings',
  },
}

const allowedItems = Object.keys(SIDE_PANEL_ITEMS).map(
  (key) => SIDE_PANEL_ITEMS[key].to
)

export const isAllowedItem = (item: string): boolean =>
  allowedItems.includes(item)

const from = (locationHistory: string[]): string => {
  if (locationHistory.length > 0) {
    return locationHistory[0].replace('/', '')
  }
  return ''
}

const to = (locationHistory: string[]): string => {
  if (locationHistory.length === 2) {
    return locationHistory[1].replace('/', '')
  }
  return ''
}

export const getItemPath = (locationHistory: string[]): string => {
  if (locationHistory.length === 1) {
    return from(locationHistory)
  } else if (locationHistory.length === 2) {
    return to(locationHistory)
  }
  return ''
}

export const shouldKeepActiveItem = (
  activeItem: string,
  locationHistory: string[]
): boolean => {
  const activeItemsToKeep = [
    SIDE_PANEL_ITEMS.SETTINGS.to,
    SIDE_PANEL_ITEMS.LIVESTREAM.to,
  ]
  if (
    isAllowedItem(activeItem) &&
    activeItem === from(locationHistory) &&
    !isAllowedItem(to(locationHistory)) &&
    activeItemsToKeep.includes(activeItem)
  ) {
    return true
  }
  return false
}

export const defaultPublicContextValue = {
  closeWithoutVerticalTranslate: false,
  hasFullWidthBackground: false,
  hasMainContentFullHeight: false,
  isSidePanelFocused: true,
  isSidePanelOpened: true,
  activeItem: '',
  isLogoHidden: false,
  withoutTransitions: false,
  setAvoidStealFocus: () => {},
  setKeepSidePanelOpened: () => {},
  setKeepLogoVisible: () => {},
  focusSidePanel: () => {},
}

export const defaultPrivateContextValue = {
  setIsSidePanelFocused: () => {},
  onItemFocus: () => {},
}
